export type FeErrorCode =
  | 'field_is_required'
  | 'address_not_found'
  | 'address_did_not_match_the_records'
  | 'unknown_error'
  | 'email_required'
  | 'password_required'
  | 'phone_required'
  | 'birth_date_required'
  | 'birth_place_required'
  | 'gender_required'
  | 'duplicate_email'
  | 'duplicate_phone'
  | 'incorrect_email'
  | 'email_forbidden'
  | 'incorrect_password'
  | 'incorrect_phone_number'
  | 'incorrect_birth_day'
  | 'user_under_age'
  | 'user_age_error'
  | 'deposit_required'
  | 'deposit_too_low'
  | 'deposit_too_high'
  | 'limit_too_low'
  | 'limit_too_high'
  | 'limit_required'
  | 'limit_lower_than_deposit'
  | 'monthly_limit_lower_than_weekly'
  | 'weekly_limit_lower_than_daily'
  | 'no_welcome_offer_notification'
  | 'nationality_is_required'
  | 'invalid_jurisdiction_for_brand'
  | 'country_restricted'
  | 'province_in_address_required'
  | 'invalid_ocr_data'
  | 'credentials_taken'
  | 'unique_player'
  | 'social_security_number_already_exists'
  | 'self_excluded_with_national_registry'
  | 'first_name_required'
  | 'last_name_required'
  | 'invalid_postalcode'
  | 'country_of_residence_is_required'
  | 'predictions_google_api_not_found'
  | 'network_error'
  | 'kyc_required'
  | 'invalid_identity'
  | 'registration_cancelled'
  | 'incorrect_details'
  | 'something_went_wrong'
  | 'pnp_init_failed'
  | 'pnp_login_failed'
  | 'pnp_deposit_unsuccessful'
  | 'generic_error_message'
  | 'duplicate_account'
  | 'id_verification_failed'
  | 'insufficient_balance'
  | 'piq_payment_failed'
  | 'money_limit_exceeded'
  | 'player_matched_but_blocked'
  | 'player_not_matched'
  | 'multiple_pno_usage'
  | 'registration_timed_out'
  | 'piq_transaction_refund';

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FE_ERROR_CODES: Record<FeErrorCode, FeErrorCode> = new Proxy({} as any, {
  get: (_t, p: string) => p,
});

export type BeReason =
  | 'EMAIL_TAKEN'
  | 'INVALID_EMAIL'
  | 'EMAIL_FORBIDDEN'
  | 'PHONE_NUMBER_ALREADY_EXISTS'
  | 'VALID'
  | 'INVALID_JURISDICTION_FOR_BRAND'
  | 'COUNTRY_RESTRICTED'
  | 'PROVINCE_IN_ADDRESS_REQUIRED'
  | 'INVALID_OCR_DATA'
  | 'CREDENTIALS_TAKEN'
  | 'UNIQUE_PLAYER'
  | 'SOCIAL_SECURITY_NUMBER_ALREADY_EXISTS'
  | 'TOO_YOUNG'
  | 'SELF_EXCLUDED_WITH_NATIONAL_REGISTRY'
  | 'REGISTRATION_METHOD_COUNTRY_MISMATCH'
  | 'CAPTCHA_INVALID_RESPONSE'
  | 'POSTAL_CODE_FORBIDDEN'
  | 'JURISDICTION_NOT_FOUND'
  | 'KYC_REQUIRED'
  | 'INVALID'
  | 'REGISTRATION_CANCELLED'
  | 'INCORRECT_DETAILS'
  | 'DUPLICATE_ACCOUNT_FOUND'
  | 'DUPLICATE_ACCOUNT'
  | 'ID_VERIFICATION_FAILED'
  | 'USER_UNDER_AGE'
  | 'INSUFFICIENT_BALANCE'
  | 'GENERIC_ERROR'
  | 'BASE_ERROR'
  | 'MONEY_LIMIT_EXCEEDED'
  | 'PLAYER_MATCHED_BUT_BLOCKED'
  | 'PLAYER_NOT_MATCHED'
  | 'MULTIPLE_PNO_USAGE'
  | 'REGISTRATION_TIMEOUT'
  | 'TRANSACTION_REFUNDED'
  | '27';

const MAP_BE_TO_FE: Partial<Record<BeReason, FeErrorCode>> = {
  BASE_ERROR:                            FE_ERROR_CODES.piq_payment_failed,
  EMAIL_TAKEN:                           FE_ERROR_CODES.duplicate_email,
  PHONE_NUMBER_ALREADY_EXISTS:           FE_ERROR_CODES.duplicate_phone,
  INVALID_JURISDICTION_FOR_BRAND:        FE_ERROR_CODES.invalid_jurisdiction_for_brand,
  COUNTRY_RESTRICTED:                    FE_ERROR_CODES.country_restricted,
  PROVINCE_IN_ADDRESS_REQUIRED:          FE_ERROR_CODES.province_in_address_required,
  INVALID_OCR_DATA:                      FE_ERROR_CODES.invalid_ocr_data,
  CREDENTIALS_TAKEN:                     FE_ERROR_CODES.credentials_taken,
  UNIQUE_PLAYER:                         FE_ERROR_CODES.unique_player,
  SOCIAL_SECURITY_NUMBER_ALREADY_EXISTS: FE_ERROR_CODES.social_security_number_already_exists,
  TOO_YOUNG:                             FE_ERROR_CODES.user_under_age,
  SELF_EXCLUDED_WITH_NATIONAL_REGISTRY:  FE_ERROR_CODES.self_excluded_with_national_registry,
  KYC_REQUIRED:                          FE_ERROR_CODES.kyc_required,
  INVALID_EMAIL:                         FE_ERROR_CODES.incorrect_email,
  EMAIL_FORBIDDEN:                       FE_ERROR_CODES.email_forbidden,
  INVALID:                               FE_ERROR_CODES.invalid_identity,
  REGISTRATION_CANCELLED:                FE_ERROR_CODES.registration_cancelled,
  INCORRECT_DETAILS:                     FE_ERROR_CODES.incorrect_details,
  DUPLICATE_ACCOUNT_FOUND:               FE_ERROR_CODES.duplicate_account,
  DUPLICATE_ACCOUNT:                     FE_ERROR_CODES.duplicate_account,
  ID_VERIFICATION_FAILED:                FE_ERROR_CODES.id_verification_failed,
  USER_UNDER_AGE:                        FE_ERROR_CODES.user_under_age,
  INSUFFICIENT_BALANCE:                  FE_ERROR_CODES.insufficient_balance,
  GENERIC_ERROR:                         FE_ERROR_CODES.generic_error_message,
  MONEY_LIMIT_EXCEEDED:                  FE_ERROR_CODES.money_limit_exceeded,
  PLAYER_MATCHED_BUT_BLOCKED:            FE_ERROR_CODES.player_matched_but_blocked,
  PLAYER_NOT_MATCHED:                    FE_ERROR_CODES.player_not_matched,
  MULTIPLE_PNO_USAGE:                    FE_ERROR_CODES.player_not_matched,
  REGISTRATION_TIMEOUT:                  FE_ERROR_CODES.registration_timed_out,
  TRANSACTION_REFUNDED:                  FE_ERROR_CODES.piq_transaction_refund,
  '27':                                  FE_ERROR_CODES.pnp_deposit_unsuccessful,
};

export const mapBeReasonToFe = (reason?: string | number): FeErrorCode => {
  if (reason === undefined || reason === null || reason === '') {
    return FE_ERROR_CODES.unknown_error;
  }
  const key = String(reason).toUpperCase() as BeReason;

  return MAP_BE_TO_FE[key] ?? FE_ERROR_CODES.unknown_error;
};
